module.exports = __webpack_public_path__ + "static/media/OpenSans-Light.9ff12f69.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/OpenSans-Light.ttf
// module id = 3173
// module chunks = 51